module.exports = __webpack_public_path__ + "media/images/front/icon_target-105a610bed5a846724ea975deb883f5a.png";